import React, { useState, useEffect } from "react";
import RigthPanel from "@/ui-controls/RigthPanel";
import { Application } from "@/api/applications";
import {
  Privilege,
  AppPrivilegeModel,
  addPrivilege,
} from "@/api/privileges";
import NewAppPrivilegeForm from "@/components/privileges/appPrivileges/NewAppPrivilegeForm";

interface Props {
  application: Application | undefined;
  isPanelOpenned: boolean;
  onSaveNewPrivilege: (privilege: Privilege) => any;
  onPanelClosed?: () => any;
  onError?: (error: any) => void;
}

const NewAppPrivilegePanel = (props: Props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  const savePrivilege = async (privilege: AppPrivilegeModel) => {
    if (!props.application) return;

    setIsSaving(true);
    try
    {
      const result = await addPrivilege({
        ...privilege,
        ApplicationId: props.application?.Id,
      });
      setIsSaving(false);
      if (props.onSaveNewPrivilege) props.onSaveNewPrivilege(result);
    }
    catch (error)
    {
      setIsSaving(false);
      if (props.onError) props.onError(error);
    }
  };

  return (
    <>
      <RigthPanel
        header="Add New Application Privilege"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewAppPrivilegeForm}
        childProps={{
          //   allUsers: props.allUsers,
          //   nonAssignedUsers: props.nonAppUsers,
          isSaving: isSaving,
          onClose: () => onClosePanel(),
          onSavePrivilege: savePrivilege,
        }}
      />
    </>
  );
};

export default NewAppPrivilegePanel;
